import { ConstructPoolPortalPartofmonthsHeaders } from "modules/PoolPortal/helpers/headers"
import {
  AdminSettingsEnum,
  PoolPortalPartofmonth,
  PoolPortalPartofmonths,
} from "modules/PoolPortal/helpers/types"
import { usePartofmonths } from "modules/PoolPortal/hooks/usePartofmonthsAPI"
import { FormatEnumToString, GetEntryPageState } from "modules/PoolPortal/utils"
import { useEffect, useState } from "react"
import { Button, Modal, Offcanvas } from "react-bootstrap"
import { SettingsEntryHOC } from "../SettingsHOC"
import { SettingsTable } from "../SettingsTable"

export const PartofmonthsAdminMain = () => {
  // UseHooks for the Partofmonths
  const { partofmonths, isLoading, deletePartofmonth } = usePartofmonths()

  const [partofmonthsData, setPartofmonthsData] = useState(
    partofmonths ?? ([] as PoolPortalPartofmonths)
  )
  const [showEntryBlade, setShowEntryBlade] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [currentPartofmonth, setCurrentPartofmonth] = useState(
    {} as PoolPortalPartofmonth
  )

  useEffect(() => {
    if (partofmonths) {
      setPartofmonthsData([...partofmonths])
    }
  }, [isLoading, partofmonths])

  const handleEditBladeClose = () => {
    setShowEntryBlade(false)
  }
  const handleEditBladeShow = () => {
    setShowEntryBlade(true)
  }

  const newPartofmonthsHandler = () => {
    setShowEntryBlade(true)
    setCurrentPartofmonth({} as PoolPortalPartofmonth)
  }

  const editPartofmonthHandler = (id: string) => {
    const data = partofmonthsData as PoolPortalPartofmonths
    if (data) {
      var foundIndex = data?.findIndex((x: PoolPortalPartofmonth) => x.id === id)
      setCurrentPartofmonth(data[foundIndex])
      handleEditBladeShow()
    }
  }

  const deletePartofmonthHandler = (id: string) => {
    // show the pop here and set the currentPartofmonth for deletion
    const data = partofmonthsData as PoolPortalPartofmonths
    if (data) {
      var foundIndex = data?.findIndex((x: PoolPortalPartofmonth) => x.id === id)
      setCurrentPartofmonth(data[foundIndex])
      setShowDelete(true)
    }
  }

  const modalDeleteHandler = async () => {
    //  actual deletion
    await deletePartofmonth(currentPartofmonth.id)
    setShowDelete(false)
  }

  return (
    <>
      <Modal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        style={{ zIndex: 5060 }}
        backdropClassName="SettingsDeleteConfirmationBackDrop"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Partofmonth</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the "{currentPartofmonth.name}"
          partofmonth?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={modalDeleteHandler}>
            Delete
          </Button>
          <Button variant="secondary" onClick={() => setShowDelete(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas
        className="PoolPortal_SettingsEditOffcanvas"
        show={showEntryBlade}
        onHide={handleEditBladeClose}
        placement="end"
        backdrop="static"
        scroll={false}
        style={{ zIndex: 4060 }}
        backdropClassName="SettingsEditOffCanvassBackDrop"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Settings - {GetEntryPageState(currentPartofmonth)}{" "}
            {FormatEnumToString(AdminSettingsEnum.PARTOFMONTH)}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SettingsEntryHOC
            type={AdminSettingsEnum.PARTOFMONTH}
            data={currentPartofmonth}
            setShowEntryBlade={setShowEntryBlade}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <SettingsTable
        body={partofmonthsData!}
        headers={ConstructPoolPortalPartofmonthsHeaders(
          editPartofmonthHandler,
          deletePartofmonthHandler
        )}
        newHandler={newPartofmonthsHandler}
      />
    </>
  )
}
